export const LOGIN_FROM_LA = 'LOGIN_FROM_LA';
export const REDIRECT_FROM_LA = 'REDIRECT_FROM_LA';
export const CLOSE_LA = 'CLOSE_LA';
export const SHOW_LA = 'SHOW_LA';
